import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';

// Actions
import { setAlert } from '../../../actions/alertActions';
import { toggleCreateSportsMatchModal, goBack } from '../../../actions/navActions';
import { createSportsMatch } from '../../../actions/sportsMatchActions';

// Switch Pages
import AddLogo_Team_1 from './AddLogo_Team_1';
import AddLogo_Team_2 from './AddLogo_Team_2';
import AddStartDate from './AddStartDate';
import AddTeamNames from './AddTeamNames';
import ChooseSport from './ChooseSport';

// Icons
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';


// Initial State 
const initialState = {
    team_1: '',
    team_2: '',
    start_day: null,
    start_time: null,
    search_tags: '',
};

const CreateMatchSlidingForm = ({ 
    nav: {
        website
    },
    setAlert,
    toggleCreateSportsMatchModal,
    goBack,
    page,
    previousUrl,
    history,
    post,
    is_create_page,
    createSportsMatch
}) => {

    // Form Data state and setter
    const [formData, setFormData] = useState(initialState);
    const [sportType, setSportType] = useState(null);
    const [logo_Team1, setLogo_Team1] = useState(null);
    const [logo_Team2, setLogo_Team2] = useState(null);

    const [processing, setProcessing] = useState(false);

    // State variables for form transitions
    const [slideform1, setSlideForm1] = useState(false);
    const [slideform2, setSlideForm2] = useState(false);
    const [slideform3, setSlideForm3] = useState(false);
    const [slideform4, setSlideForm4] = useState(false);
    const [slideform5, setSlideForm5] = useState(false);
    const [slideform6, setSlideForm6] = useState(false);

    // --- Edit profile info logic ---

    const { 
        team_1, 
        team_2,
        start_day,
        start_time,
        search_tags
    } = formData;

    // Form input change handler
    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value});

    // Triggered when the bio form is submitted
    // const bioTodo = (e) => {
    //     onSubmitBio(e);
    // }

    const handleGoBack = (e) => {
        e.preventDefault();
        toggleCreateSportsMatchModal();
        setFormData(initialState);
        if(page) {
            if(previousUrl !== null) {
                if(previousUrl === 'create' || previousUrl === 'create_home') {
                    history.push(`/create/post?goBack=home`);
                } else if(previousUrl === 'create_detail') {
                    history.push(`/create/post?goBack=detail`);
                } else if(previousUrl === 'create_profile') {
                    history.push(`/create/post?goBack=profile`);
                } else if(previousUrl === 'comment') {
                    if(post) {
                        history.push(`/create/comment/${post._id}`);
                    } else {
                        goBack();
                    }
                } else {
                    history.push(`/${previousUrl}`);
                }
            } 
        }
    }

    const handleSubmit = async () => {
        setProcessing(true);
        try {

            await createSportsMatch({
                formData: {
                    team_1_name: team_1, 
                    team_2_name: team_2,
                    start_day,
                    start_time,
                    sport_type: sportType, 
                    search_tags: search_tags
                }, 
                team_logos: {
                    team_1_logo: logo_Team1,
                    team_2_logo: logo_Team2
                },
                group_id: website?._id
            });
            // will redirect to group page if function is successful
        } catch (error) {
            console.log("Error - Failed trying to create group"); 
            console.log(error);
            setProcessing(false);
            setAlert('Something went wrong!');
        }
    }

    return (
        <Fragment>
            {/* Render close button if on full categoryPage for mobile */}
            {!is_create_page && (
                <div onClick={handleGoBack} style={{margin: '20px'}} className="form__backBtn right">
                    <CloseOutlinedIcon />
                </div>
            )}
            <div style={{width:'100%'}} className="form-transition">

                {/* Add Photo Form */}
                <div id="transition-1" style={{width:'100%'}} className={!slideform1 ? "auth-form-container active" : "auth-form-container"}>
                    <AddTeamNames is_create_page={is_create_page} slideform1={slideform1} setSlideForm1={setSlideForm1} formData={formData} onChange={onChange} handleGoBack={handleGoBack} />
                </div>

                <div id="transition-2" style={{width:'100%'}} className={slideform1 ? "auth-form-container active" : "auth-form-container"}>
                    <div style={{width:'100%'}} className="form-transition">

                        {/* Add Bio Form */}
                        <div id="transition-1" style={{width:'100%'}} className={!slideform2 ? "auth-form-container active" : "auth-form-container"}>
                            <ChooseSport is_create_page={is_create_page} slideform1={slideform1} setSlideForm1={setSlideForm1} slideform2={slideform2} setSlideForm2={setSlideForm2} sportType={sportType} setSportType={setSportType} />
                        </div>

                        {/* Confirmation Slide - no inputs or actions here */}
                        <div id="transition-2" style={{width:'100%'}} className={slideform2 ? "auth-form-container active" : "auth-form-container"}>
                            <div style={{width:'100%'}} className="form-transition">

                                {/* Add Bio Form */}
                                <div id="transition-1" style={{width:'100%'}} className={!slideform3 ? "auth-form-container active" : "auth-form-container"}>
                                    <AddStartDate is_create_page={is_create_page} slideform2={slideform2} setSlideForm2={setSlideForm2} slideform3={slideform3} setSlideForm3={setSlideForm3} formData={formData} onChange={onChange} />
                                </div>

                                {/* Confirmation Slide - no inputs or actions here */}
                                <div id="transition-2" style={{width:'100%'}} className={slideform3 ? "auth-form-container active" : "auth-form-container"}>
                                    <div style={{width:'100%'}} className="form-transition">

                                        {/* Add Bio Form */}
                                        <div id="transition-1" style={{width:'100%'}} className={!slideform4 ? "auth-form-container active" : "auth-form-container"}>
                                            <AddLogo_Team_1 is_create_page={is_create_page} handleSubmit={handleSubmit} slideform3={slideform3} setSlideForm3={setSlideForm3} slideform4={slideform4} setSlideForm4={setSlideForm4} setLogo_Team1={setLogo_Team1} setAlert={setAlert} processing={processing} />
                                        </div>

                                        {/* Confirmation Slide - no inputs or actions here */}
                                        <div id="transition-2" style={{width:'100%'}} className={slideform4 ? "auth-form-container active" : "auth-form-container"}>
                                            <AddLogo_Team_2 is_create_page={is_create_page} handleSubmit={handleSubmit} slideform4={slideform4} setSlideForm4={setSlideForm4} setLogo_Team2={setLogo_Team2} setAlert={setAlert} processing={processing} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </Fragment>
    )
}

CreateMatchSlidingForm.propTypes = {
    // Prop type validation for authentication
    nav: PropTypes.object.isRequired,
    setAlert: PropTypes.func.isRequired,
    toggleCreateSportsMatchModal: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
    createSportsMatch: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
    
    // Mapping the authentication state
    nav: state.nav
});

export default connect(mapStateToProps, { 

    // Connecting actions to the component
    setAlert,
    toggleCreateSportsMatchModal,
    goBack,
    createSportsMatch
})(CreateMatchSlidingForm);
